<div class="container">
    <mat-card>
        <h2 mat-title>Cotización</h2>
        <form [formGroup]="catizcionesForma" (ngSubmit)="submit()">
            <mat-card-content fxLayout="column">
                
                <mat-form-field>
                    <mat-label>Seleccionar tipo de cotización</mat-label>
                    <mat-select formControlName="reportType" (selectionChange)="onReportTypeChange($event.value)" required>
                        <mat-option *ngFor="let opt of cotizacionesTypo" [value]="opt.value">
                            {{ opt.displayName }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="catizcionesForma.controls.reportType.hasError('required')">
                        La selección <strong>obligatorio</strong>
                    </mat-error>
                </mat-form-field>
             
                <mat-form-field *ngIf="catizcionesForma.controls['searchData']" >
                    <mat-label>Buscar datos</mat-label>
                    <input type="text" matInput formControlName="searchData">
                    <mat-error *ngIf="catizcionesForma.hasError('required')">
                      Número de cuenta y nombre de cliente son <strong>obligatorios</strong>
                    </mat-error>
                  </mat-form-field>                  
                             
                <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
                    <button type="button" mat-raised-button [routerLink]="['/home']">Cancelar</button>
                    <button mat-raised-button color="primary" [disabled]="!catizcionesForma.valid">Generar</button>
                </mat-card-actions>

                
            </mat-card-content>
        </form>
    </mat-card>
    <mat-card *ngIf="totalRecords > 0">
        <mat-card-content>
            <!-- Display the Angular Material Table -->
            <table mat-table [dataSource]="data.pageItems" class="mat-elevation-z0">
                <!-- Replace 'columnDef' with appropriate column names and 'displayedColumns' with column IDs -->
                <ng-container matColumnDef="ID">
                  <th mat-header-cell *matHeaderCellDef>ID</th>
                  <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
                </ng-container>
                <ng-container matColumnDef="Parent Name">
                  <th mat-header-cell *matHeaderCellDef>Parent Name</th>
                  <td mat-cell *matCellDef="let element">{{ element.parentName }}</td>
                </ng-container>
                <ng-container matColumnDef="Loan Account No">
                  <th mat-header-cell *matHeaderCellDef>Loan Account No</th>
                  <td mat-cell *matCellDef="let element">{{ element.entityAccountNo }}</td>
                </ng-container>
                <ng-container matColumnDef="Product Name">
                  <th mat-header-cell *matHeaderCellDef>Product Name</th>
                  <td mat-cell *matCellDef="let element">{{ element.entityName }}</td>
                </ng-container>
              
                <!-- Replace 'displayedColumns' with column IDs -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <div *ngIf="catizcionesForma.controls.reportType.value === 'cacelacione_'">
                  <ng-container  *matRowDef="let row; columns: displayedColumns">
                    <tr mat-row  [routerLink]="['cancalecione', row.entityId]"></tr>
                  </ng-container>
                </div>
                <div *ngIf="catizcionesForma.controls.reportType.value === 'abono_'">
                  <ng-container  *matRowDef="let row; columns: displayedColumns">
                    <tr mat-row  [routerLink]="['abono-capital', row.entityId]"></tr>
                  </ng-container>
                </div>
               
              </table>
            
            <!-- Add pagination controls -->
            <mat-paginator
                [pageSize]="pageSize"
                [length]="totalRecords"
                [pageSizeOptions]="[5, 10]"
                (page)="onPageChange($event)">
            </mat-paginator>
  
        </mat-card-content>
    </mat-card>
</div>